import { useTheme } from 'styled-components'
import { Container, Typography } from '..'
import { NavPillProps } from './type'
import SupportIcon from '../../assets/svg/supportIcon'
import UserProfileIcon from '../../assets/svg/userProfileIcon'
import StyledNavPill from './StyledNavPill/StyledNavPill'
import StyledIconContainer from './StyledIconContainer/StyledIconContainer'

const NavPill = ({ onClick, showIcon, type, displayValue }: NavPillProps) => {
    const theme = useTheme()
    const iconTypes = {
        support: <SupportIcon fill={theme.color.text.subHeading} />,
        user: <UserProfileIcon fill={theme.color.text.subHeading} />
    }
    const icon = iconTypes[type]

    return (
        <StyledNavPill className='flex' onClick={onClick}>
            {showIcon && !!icon && (
                <StyledIconContainer className='flex flex-middle icon-container'>
                    {icon}
                </StyledIconContainer>
            )}
            <Container style={{ maxWidth: '74px' }}>
                <Typography className='tt-ellipsis' variant='P3'>
                    {displayValue}
                </Typography>
            </Container>
        </StyledNavPill>
    )
}

export default NavPill
